import React, { Component } from "react";

import DocumentBody from "./communications-cards/DocumentBody";
import PolicyEventBody from "./communications-cards/PolicyEventBody";
import OtherServiceRequestsBody from "./communications-cards/OtherServiceRequestsBody";
import PolicyCancellationRequests from "./communications-cards/PolicyCancellationRequests";
import BindRequest from "./communications-cards/BindRequest";
import Endorsement from "./communications-cards/Endorsement";

class CommunicationsCard extends Component {
  render() {
    let element = null;
    let backgroundColor = "#fff";

    switch (this.props.data.Type) {
      case "Document":
        element = <DocumentBody data={this.props.data} />;
        break;
      case "PolicyEvents":
        element = <PolicyEventBody data={this.props.data} />;
        break;
      case "OtherServiceRequests":
        element = <OtherServiceRequestsBody data={this.props.data} />;
        break;
      case "PolicyCancellationRequests":
        element = <PolicyCancellationRequests data={this.props.data} />;
        break;
      case "BindRequest":
        element = <BindRequest data={this.props.data} />;
        break;
      case "Endorsements":
        element = <Endorsement data={this.props.data} />;
        break;
      default:
        break;
    }

    return (
      element && (
        <div className="four-panel-small four-panel-small-margin-top">
          <div
            className="four-panel-small-content"
            style={{ backgroundColor: backgroundColor }}
          >
            {element}
          </div>
        </div>
      )
    );
  }
}

export default CommunicationsCard;
